/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_Addmembersaction2Inputs */

const en_cases_settings_category_addmembersaction2 = /** @type {(inputs: Cases_Settings_Category_Addmembersaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Cases_Settings_Category_Addmembersaction2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_addmembersaction2 = /** @type {((inputs?: Cases_Settings_Category_Addmembersaction2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Addmembersaction2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_addmembersaction2(inputs)
});
export { cases_settings_category_addmembersaction2 as "cases_settings_category_addMembersAction" }